import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSettingsConfig } from '../reduxStore/entities/configs';

const useSettingsConfig = () => {
    const dispatch = useDispatch();
    const { settingsConfig, settingsConfigLoaded } = useSelector((state) => state.configs);

    React.useEffect(() => {
        dispatch(getSettingsConfig());
    }, []);

    return {
        settingsConfig,
        settingsConfigLoaded,
    };
};

export default useSettingsConfig;
